import React, { Component } from 'react';
import PropTypes from 'prop-types';

import PaginateItem from 'components/common/paginate/item';

const propTypes = {
  maxMargin: PropTypes.number,
  onClick: PropTypes.func,
  selectedPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
};

const defaultProps = {
  maxMargin: 4,
  onClick: () => {},
};

class Paginate extends Component {
  get isSelectionInFirstHalf() {
    const { selectedPage, totalPages } = this.props;

    return totalPages / 2 >= selectedPage;
  }

  get smallestGap() {
    const { selectedPage, totalPages } = this.props;
    const closestEnd = this.isSelectionInFirstHalf ? 1 : totalPages;

    return Math.abs(selectedPage - closestEnd);
  }

  get isTotalPagesAboveMinimum() {
    const { totalPages } = this.props;

    return totalPages > 5;
  }

  renderArrow(arrowDirection, destinationPage) {
    const { onClick } = this.props;
    return (<PaginateItem
      key={`${arrowDirection}-arrow`}
      className={`iconified-font iconified-chevron-${arrowDirection}`}
      onClick={() => onClick(destinationPage)}
    />);
  }

  renderLeftSide() {
    const { maxMargin, onClick, selectedPage } = this.props;

    const leftItems = [
      this.renderArrow('left', selectedPage - 1),
      <PaginateItem onClick={() => onClick(1)} key={1} value={1} />,
    ];

    const shouldShowEllipsis = this.isTotalPagesAboveMinimum &&
      (!this.isSelectionInFirstHalf || this.smallestGap > maxMargin);

    if (shouldShowEllipsis) {
      leftItems.push(<PaginateItem key="left-ellipsis" value="..." className="disabled" />);
      const previous = selectedPage - 1;
      leftItems.push(<PaginateItem onClick={() => onClick(previous)} key={previous} value={previous} />);
    } else {
      for (let i = 2; i < selectedPage; i++) {
        leftItems.push(<PaginateItem onClick={() => onClick(i)} key={i} value={i} />);
      }
    }

    return leftItems;
  }

  renderRightSide() {
    const { maxMargin, onClick, selectedPage, totalPages } = this.props;

    const rightItems = [
      <PaginateItem key={totalPages} onClick={() => onClick(totalPages)} value={totalPages} />,
      this.renderArrow('right', selectedPage + 1),
    ];

    const shouldShowEllipsis = this.isTotalPagesAboveMinimum &&
      (this.isSelectionInFirstHalf || this.smallestGap > maxMargin);

    if (shouldShowEllipsis) {
      rightItems.unshift(<PaginateItem className="disabled" key="right-ellipsis" value="..." />);
      const next = selectedPage + 1;
      rightItems.unshift(<PaginateItem key={next} onClick={() => onClick(next)} value={next} />);
    } else {
      for (let i = totalPages - 1; i > selectedPage; i--) {
        rightItems.unshift(<PaginateItem key={i} onClick={() => onClick(i)} value={i} />);
      }
    }

    return rightItems;
  }

  render() {
    const { onClick, selectedPage, totalPages } = this.props;
    if (totalPages < 2) return null;

    return (
      <div className="paginate">
        {selectedPage !== 1 && this.renderLeftSide()}
        <PaginateItem onClick={onClick} value={selectedPage} selected />
        {selectedPage !== totalPages && this.renderRightSide()}
      </div>
    );
  }
}

Paginate.propTypes = propTypes;
Paginate.defaultProps = defaultProps;

export default Paginate;
